import React, {useContext, useEffect, useState} from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import {Form, Formik} from 'formik';
import {Button, Card, Grid} from '@mui/material';
import {DispatchContext} from '../../../../store';
import {useNavigate} from 'react-router';
import {useLocation} from 'react-router-dom';
import {SNACKBAR_OPEN} from '../../../../reducers';
import TransferEntryOneUpdate from './TransferEntryOneUpdate';
import TransferEntryTwoUpdate from './TransferEntryTwoUpdate';
import TransferEntryThreeUpdate from './TransferEntryThreeUpdate';
import {transfersAction} from '../../../../services/TransferServices';

export default function TransferUpdate(props) {
  const dispatch = useContext(DispatchContext);
  const navigate = useNavigate();
  const [transfer, setTransfer] = useState({});
  const transferData = transfer?.catalogue;
  const [loanImgIds, setLoanImgIds] = useState([]);
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const id = params.get('id');
  const code = 'en';
  const initialValues = {
    ...transfer,
    ...transferData
  };

  useEffect(() => {
    getTransferUpdateData();
  }, []);

  const getTransferUpdateData = () => {
    transfersAction('get', id).then(res => {
      setTransfer({
        ...res?.data,
      });
    })
  }

  const onSubmit = (values) => {

    const loanValues = {
      recipient_museum_id: values?.recipient_museum_id,
      sender_museum_id: values?.sender_museum_id,
      accession_no: values?.accession_no,
      catalogue_id: values?.catalogue?.id,
      attachment_ids: values?.attachments?.map(val => val?.id),
      translations: {
        en: {
          remarks: values?.remarks,
        }
      }
    }

    transfersAction('put', id, {...loanValues}).then(res => {
      dispatch({
        type: SNACKBAR_OPEN,
        payload: {isNotify: true, severity: 'success', message: 'Request resubmitted successful'}
      });
      navigate(`/management/artifact-managements`)
    })
  }

  return (
    <div>
      <Box sx={{display: {sm: 'flex', xs: 'column'}, alignItems: 'center', mt: 7, mb: 2}}>
        <Typography className={'text-500 font30'} sx={{color: '#757575'}}>Transfer Request</Typography>
      </Box>
      <Box className={'header-divider'}/>
      <Formik initialValues={initialValues}
              onSubmit={onSubmit}
              validateOnBlur={true} enableReinitialize
      >
        {({isSubmitting, touched, errors, values, setFieldValue, ...formik}) => (
          <Form>
            <Box sx={{mb: {sm: 4, xs: 2}}}>
              <Grid container spacing={2}>
                <Grid item sm={4} xs={12}>
                  <TransferEntryOneUpdate code={code}/>
                </Grid>
                <Grid item sm={4} xs={12}>
                  <TransferEntryTwoUpdate code={code}/>
                </Grid>
                <Grid item sm={4} xs={12}>
                  <TransferEntryThreeUpdate code={code} id={id}/>
                </Grid>
              </Grid>
              <Box className={'dotted-divider'}/>
              <Grid container spacing={2}>
                <Grid item sm={4} xs={12}>
                  <Card className={'box-shadow'} sx={{p: 4}}>
                    {values?.catalogue?.attachments?.map((val, index) => (
                      <div key={index} className={'flex'}>
                        <img src={val?.file} width={70} height={70} style={{marginRight: 3}} alt="catalog_image"/>
                      </div>
                    ))}
                  </Card>
                </Grid>
              </Grid>
              <Box>
                <Grid container spacing={2}>
                  <Grid item sm={9} xs={12}/>
                  <Grid item sm={3} xs={12}>
                    <Grid container spacing={2}>
                      <Grid item sm={6} xs={12}>
                        <Button onClick={() => navigate(-1)} variant={'outlined'} color={'error'}
                                fullWidth>Cancel</Button>
                      </Grid>
                      <Grid item sm={6} xs={12}>
                        <Button variant={'contained'} type={'submit'} fullWidth>Update</Button>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Box>
            </Box>
          </Form>
        )}
      </Formik>
    </div>
  );
}